import React, { useEffect } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCIcon, RCCTooltip} from "react-common-components";
import { useFieldArray } from "react-hook-form";
import SortableContainer from "src/components/Sortable/Container";
import SortableItem from "src/components/Sortable/Item";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import { restrictToVerticalAxis } from "src/components/Sortable/Container/modifiers";
import { IComponentPhases } from "./interface";
import Phase from "./phase";

const Phases: React.FC<IComponentPhases> = ({
	control,
	error,
	controlHours,
	phasesDefaultValue,
	isDisabled,
	isCopy,
	register,
	unregister,
	clearErrors
}) => {
	const { translate } = useTranslation();

	const { 
		fields: fieldsPhase, 
		remove: removePhase,
		append: appendPhase,
		move: movePhase
	} = useFieldArray({
		control,
		name: "prtba003",
		shouldUnregister: true
	});

	const addPhase = () => {
		clearErrors("prtba003");
		const phase: any = {};
		phase.id = isDisabled ? "disabled" : v4();
		phase.key = phase.id;
		phase.pra003Id = 0;
		phase.pra003Titulo = "";

		appendPhase(phase);
	};

	const handleRemoveRestriction = (index: number) => {			
		removePhase(index);
	};

	const handleDragEnd = (activeId: string, overId: string) => {
		const activeIndex = fieldsPhase.findIndex((checks) => checks.id === activeId);
		const overIndex = fieldsPhase.findIndex((checks) => checks.id === overId);
		movePhase(activeIndex, overIndex);
		unregister("prtba003");
	};

	useEffect(() => {
		appendPhase(phasesDefaultValue.map((phases: any) => ({
			...phases,
			id: isDisabled ? "disabled" : v4()
		})));
	}, []);

	return (
		<RCCGrid
			container
			item
			direction="column"
			alignItems="center"
			justifyContent="center"
		>
			<RCCGrid
				container
				item
				xs={12}
				sm={10}
				md={8}
				lg={8}
			>
				<RCCGrid
					container
					item
				>
					<RCCGrid
						container
						item
						justifyContent="flex-end"
					>
						<RCCTooltip
							color="purple"
							text={translate("Adicionar Fase")}
						>
							<RCCButton
								color="purple"
								icon={{
									name: "plus"
								}}
								layout="isRounded"
								size="md"
								onClick={addPhase}
								disabled={isDisabled}
							/>
						</RCCTooltip>
					</RCCGrid>
				</RCCGrid>
								
				<RCCGrid
					container
					item
				>
					{error.prtba009 && error.prtba009.message && (
						<Title color="red" size="xs">
							<RCCIcon
								name="infoCircle"
								color="var(--red)"
								style={{ marginRight: "8px"}}
							/>
							{error.prtba008.message}
						</Title>
					)}
					{fieldsPhase.length === 0 && (
						<RCCAlert
							color="grey"
							title={translate("Nenhuma fase adicionada")}
							description={translate("Aperte no botão acima para adicionar")}
						/>
					)}
					<SortableContainer 
						items={fieldsPhase}
						onDragEnd={handleDragEnd}
						modifiers={[restrictToVerticalAxis]}
					>	
						{fieldsPhase.map((phase: any, index: number) => (
							<SortableItem id={phase.id} key={phase.key ? phase.key : `phase-${phase.pra003Id}`}>
								<Phase 
									index={index}
									error={error}
									control={control}
									register={register}
									isCopy={isCopy}
									isDisabled={isDisabled}
									phase={phase}
									controlHours={controlHours}
									handleRemoveRestriction={handleRemoveRestriction}
								/>
							</SortableItem>
						))}
					</SortableContainer>
				</RCCGrid>
			</RCCGrid>
		</RCCGrid>
	);
};

export default Phases;
